import * as Dismissibles from 'js/utils/dismissibles';
import User from './core_post_webpack/models/user';

export type QualarooData = {
  route__controller?: string;
  route__action?: string;
  user_id?: number;
  premium?: boolean;
  author?: boolean;
  country?: string;
};

declare global {
  interface Window {
    // Set in layout/_base.html.erb
    qualarooInitialization?: QualarooData;

    // Set in this file
    _kiq?: [string, ...any][];
  }
}

class Qualaroo {
  url: string;
  extraData: { [key: string]: any } = {};
  constructor(url: string) {
    this.url = url;
  }

  loadScript() {
    if (window._kiq) return;
    window._kiq = window._kiq || [];
    (() => {
      setTimeout(() => {
        const d = document;
        const f = d.getElementsByTagName('script')[0];
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = this.url;
        f.parentNode?.insertBefore(s, f);
      }, 1);
    })();
  }

  showSurvey(surveyId: string, ignoreTargeting = false) {
    this.addFunctionCall('showSurvey', surveyId, ignoreTargeting);
  }

  identify(id: number) {
    this.addFunctionCall('identify', id);
  }

  addExtra(extraData: { [key: string]: any }) {
    this.extraData = {
      ...this.extraData,
      ...extraData,
    };

    this.setExtra(this.extraData);
  }

  setExtra(extraData: { [key: string]: any }) {
    this.addFunctionCall('set', extraData);
  }

  eventHandler(event: 'show' | 'noTargetMatch', callback: () => void) {
    this.addFunctionCall('eventHandler', event, callback);
  }

  addFunctionCall(name: string, ...args: any[]) {
    // technically this won't just throw a string, but it will stop executing and it will include the text, so it's close enough
    if (!window._kiq) throw 'needs initialized';

    window._kiq.push([name, ...args]);
  }
}

export function maybeInitializeQualaroo() {
  setTimeout(() => {
    if (window.qualarooInitialization) {
      startQualaroo(window.qualarooInitialization);
    }
  }, 1);
}

let instance: Qualaroo | null = null;
export function startQualaroo(
  data: { [key: string]: any } = {},
  failCallback: () => void = () => {},
) {
  // Inserts Qualaroo scripts and user params that we need to send to Qualaroo (3rd party service)
  // Sign into Qualaroo to see snippet: https://app.qualaroo.com/sites/70993/install/paste_code
  const url =
    window.$rails_env === 'development'
      ? 'https://cl.qualaroo.com/ki.js/74421/hlh.js'
      : 'https://cl.qualaroo.com/ki.js/74421/hl8.js';

  const user_identifier = User.current ? User.current.id : data.user_id;

  if (!instance) {
    instance = new Qualaroo(url);
    instance.loadScript();
    instance.identify(user_identifier);
    instance.eventHandler('show', () => {
      Dismissibles.recordShow('BackgroundQualarooSurvey');
    });
    instance.eventHandler('noTargetMatch', () => {
      failCallback();
    });
  }

  const extraData = {
    route__controller: window.$controller_name,
    route__action: window.$action_name,
    user_id: user_identifier,
    premium: User.current?.premium,
    ...data,
  };

  instance.addExtra(extraData);
  return instance;
}
